import { render } from "./DateComponent.vue?vue&type=template&id=6530409c"
import script from "./DateComponent.vue?vue&type=script&lang=js"
export * from "./DateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__